// Meta (Facebook) Pixel — customer storefront only (never on /cook or /admin).
// Loads the base library once, then fires PageView on init and on every
// in-app customer route change.

const PIXEL_ID = '4370882353125025';
let loaded = false;

function loadBaseLibrary() {
    if (window.fbq) return;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
}

// Load + init the pixel once (no PageView here — the caller fires PageView so
// the very first load isn't double-counted).
export function initMetaPixel() {
    if (loaded) return;
    loaded = true;
    loadBaseLibrary();
    window.fbq('init', PIXEL_ID);
}

// Track a PageView (fbq queues calls until the library finishes loading).
export function trackPageView() {
    if (loaded && window.fbq) window.fbq('track', 'PageView');
}

// Generic sender. Standard events use `track`; custom events use `trackCustom`.
function send(kind, event, params) {
    if (window.fbq) window.fbq(kind, event, params || {});
}

// AddToCart — dish names + customer id.
export function trackAddToCart({ dishNames, customerId } = {}) {
    send('track', 'AddToCart', {
        content_type: 'product',
        content_name: Array.isArray(dishNames) ? dishNames.join(', ') : dishNames,
        customer_id: customerId,
    });
}

// Purchase — payment method, order value, discount value.
export function trackPurchase({ paymentMethod, value, discountValue, currency = 'INR' } = {}) {
    send('track', 'Purchase', {
        value,
        currency,
        payment_method: paymentMethod,
        discount_value: discountValue,
    });
}

// Unserviceable (custom) — lat/long, pincode, address line.
export function trackUnserviceable({ lat, lng, pincode, addressLine } = {}) {
    send('trackCustom', 'Unserviceable', {
        latitude: lat,
        longitude: lng,
        pincode,
        address_line: addressLine,
    });
}
